<ng-container *transloco="let t; prefix: 'flights.panel'">
  <app-panel-body>
    <form class="flex min-h-0 flex-1 flex-col" [formGroup]="form" (ngSubmit)="save()">
      <div class="min-h-0 flex-1 overflow-y-auto">
        <app-content-container>
          <div class="space-y-4">
            @if (currentTrip()?.airportConfirmed && currentTrip()?.airport) {
              <p class="text-sm text-secondary-text">
                {{ t('designatedAirport') }} <strong>{{ currentTrip()?.airport }}</strong>
              </p>
            }

            <div>
              <label class="mb-1 block text-sm font-medium" for="flight-direction">{{ t('direction') }}</label>
              <select id="flight-direction" class="w-full rounded-md border border-primary-border bg-primary-bg px-3 py-2 text-sm" formControlName="direction">
                <option [ngValue]="flightDirections.toLocation">{{ t('to') }} {{ currentTrip()?.locationName }}</option>
                <option [ngValue]="flightDirections.returningHome">{{ t('returningHome') }}</option>
              </select>
            </div>

            <div class="grid grid-cols-1 gap-4 md:grid-cols-2">
              <div>
                <label class="mb-1 block text-sm font-medium" for="flight-airline">{{ t('airline') }}</label>
                <input id="flight-airline" type="text" class="w-full rounded-md border border-primary-border bg-primary-bg px-3 py-2 text-sm" formControlName="flightline" />
              </div>
              <div>
                <label class="mb-1 block text-sm font-medium" for="flight-num">{{ t('flightNum') }}</label>
                <input id="flight-num" type="text" class="w-full rounded-md border border-primary-border bg-primary-bg px-3 py-2 text-sm" formControlName="flightnum" />
              </div>
            </div>

            <div class="grid grid-cols-1 gap-4 md:grid-cols-3">
              <div>
                <label class="mb-1 block text-sm font-medium" for="flight-from-port">{{ t('departureAirport') }}</label>
                <input id="flight-from-port" type="text" maxlength="3" class="w-full rounded-md border border-primary-border bg-primary-bg px-3 py-2 text-sm uppercase" formControlName="flightfromport" placeholder="ABC" />
              </div>
              <div>
                <label class="mb-1 block text-sm font-medium" for="flight-from-date">{{ t('departureDate') }}</label>
                <input id="flight-from-date" type="date" class="w-full rounded-md border border-primary-border bg-primary-bg px-3 py-2 text-sm" formControlName="flightfromdate" />
              </div>
              <div>
                <label class="mb-1 block text-sm font-medium" for="flight-from-time">{{ t('departureTime') }}</label>
                <input id="flight-from-time" type="time" class="w-full rounded-md border border-primary-border bg-primary-bg px-3 py-2 text-sm" formControlName="flightfromtime" />
              </div>
            </div>

            <div class="grid grid-cols-1 gap-4 md:grid-cols-3">
              <div>
                <label class="mb-1 block text-sm font-medium" for="flight-to-port">{{ t('arrivalAirport') }}</label>
                <input id="flight-to-port" type="text" maxlength="3" class="w-full rounded-md border border-primary-border bg-primary-bg px-3 py-2 text-sm uppercase" formControlName="flighttoport" placeholder="XYZ" />
              </div>
              <div>
                <label class="mb-1 block text-sm font-medium" for="flight-to-date">{{ t('arrivalDate') }}</label>
                <input id="flight-to-date" type="date" class="w-full rounded-md border border-primary-border bg-primary-bg px-3 py-2 text-sm" formControlName="flighttodate" />
              </div>
              <div>
                <label class="mb-1 block text-sm font-medium" for="flight-to-time">{{ t('arrivalTime') }}</label>
                <input id="flight-to-time" type="time" class="w-full rounded-md border border-primary-border bg-primary-bg px-3 py-2 text-sm" formControlName="flighttotime" />
              </div>
            </div>

            <div>
              <label class="mb-1 block text-sm font-medium" for="flight-size">{{ t('numPeople') }}</label>
              <input id="flight-size" type="number" min="0" class="w-full rounded-md border border-primary-border bg-primary-bg px-3 py-2 text-sm" formControlName="size" />
            </div>
          </div>
        </app-content-container>
      </div>

      <div class="flex shrink-0 justify-end gap-3 border-t border-primary-border px-4 py-4">
        <button type="button" class="rounded-md border border-primary-border bg-primary-bg px-4 py-2 text-sm font-semibold text-primary-text hover:bg-secondary-bg" (click)="cancel()" [disabled]="submitting()">
          {{ t('cancel') }}
        </button>
        <button type="submit" class="btn btn-primary btn-no-grow disabled:opacity-50" [disabled]="submitting() || form.invalid">
          {{ isEdit() ? t('saveChanges') : t('addFlight') }}
        </button>
      </div>
    </form>
  </app-panel-body>
</ng-container>
